/**
 * @file seo.ts
 * @description Подсказки экрана «Сайт → SEO» (phase19.16 Р1; SB44, SB45,
 * SB88; фаза §7.7): образец строки в поиске, адреса карты сайта и robots.
 * Код подтверждения из мета-тега с Р3в разбирает shared
 * `parseVerificationCode` (SEO1, до 5 кодов).
 */

/** Заголовок страницы с окончанием магазина: «Каталог — Магазин» (SB88). */
export function titleWithSuffix(title: string, suffix: string | null): string {
  return suffix ? `${title}${suffix}` : title;
}

/** Описание длиннее этого поиск обрежет (uiux §5). */
export const SEO_DESCRIPTION_SOFT_MAX = 160;

/** Адрес служебного файла сайта: `https://site.ru/sitemap.xml`. */
export function siteFileUrl(siteUrl: string, file: "sitemap.xml" | "robots.txt"): string {
  return `${siteUrl.replace(/\/+$/, "")}/${file}`;
}

/** Хост сайта для образца строки поиска: «site.ru › catalog». */
export function siteHost(siteUrl: string | null): string {
  if (!siteUrl) return "ваш-сайт.ru";
  try {
    return new URL(siteUrl).host;
  } catch {
    return siteUrl;
  }
}

